export const eventTypes = {
    ADD_TO_CART: 'evelin:navigate:cart',
    SHOW_MAP_VIEW: 'evelin:map:containerClick',
};
